import RestrictVolume from "./restrict-volume";
import RestrictModel from "./restrict-model";
import RestrictTree from "./restrict-tree";
import RestrictGroup from "./restrict-group";

class RestrictMesh {
    constructor() {
        {
            this.restrictionControllers = {
                Volume: new RestrictVolume(),
                Model: new RestrictModel(),
                Group: new RestrictGroup(),
                Tree: new RestrictTree()
            };
        }
    }

    // rules: an Array of object with properties -> type(string), mode(string), names(array of string)
    // applyTo: array of string containing restricted mesh type
    updateRules(rules = [], applyTo = []) {
        try {
            rules.forEach(rule => {
                const controller = this.restrictionControllers[rule.type];
                if (!controller) return;

                const data = controller.getPopulatedDataByType(rule.meshObjects, rule.type, rule.mode);
                controller.updateDataBasedOnMode(rule.mode, data);
                applyTo.forEach(appliedType => {
                    if (appliedType === rule.type) return;
                    const data = controller.getPopulatedDataByType(rule.meshObjects, appliedType, rule.mode);
                    const appliedController = this.restrictionControllers[appliedType];
                    if (appliedController) {
                        appliedController.updateDataBasedOnMode(rule.mode, data);
                    }
                });
            });
        } catch (error) {
            console.error('error updating rules. Error: ' + error);
        }
    }

    isValid(restrictedMeshType = undefined, meshNames = []) {
        const controller = this.restrictionControllers[restrictedMeshType];
        return controller ? controller.isValid(meshNames) : true;
    }

    updateRestrictionStatus(status) {
        for (const type in this.restrictionControllers) this.restrictionControllers[type].updateRestrictionStatus(status);
    }

    clear() {
        for (const type in this.restrictionControllers) this.restrictionControllers[type].clear();
    }
}

export default RestrictMesh;
